import API from "@/models/API";

export default class Redemptions {
    constructor(item = {}) {
        
    }

    static get = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/gifts-to-suppliers${query}`);

    static getVouchers = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/gifts-to-suppliers/vouchers${query}`);

    static getAllGifts = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/gifts-to-suppliers/company-all-vouchers${query}`);

    static getSuppliers = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/suppliers`);

    static getExportedFileStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-redeemed-gifts`
        );

    static exportFile = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-redeemed-gifts`,
            item
        );

    static deleteExportedFile = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-redeemed-gifts/${id}`
        );

    static getExportedVoucherStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-gift-vouchers`
        );

    static exportVoucher = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-gift-vouchers`,
            item
        );

    static deleteExportedVoucher = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-gift-vouchers/${id}`
        );

    static cancelGift = id =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/gifts-to-suppliers/cancel-coupon-claim`, {transaction_id:id}
        );


        static getExportedAllVouchersStatus = () =>
            API.get(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/export/company-all-vouchers`
            );
    
        static exportAllVouchers = item =>
            API.post(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/export/company-all-vouchers`,
                item
            );
    
        static deleteExportedAllVouchers = id =>
            API.delete(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/export/company-all-vouchers/${id}`
            );
        
   
}
